import status from './components/StepStatus.vue'

const components = [ status ]

const install = Vue => {
  components.map(component => Vue.component(component.name, component))
}

export default {
  install
}


// WEBPACK FOOTER //
// ./src/plugins/index.js